<template>
    <q-input
        :model-value="modelValue"
        outlined
        dense
        mask="##/##/####"
        placeholder="DD/MM/YYYY"
        hide-bottom-space
        :disable="disable"
        :rules="fieldRules"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy transition-show="scale" transition-hide="scale">
                    <q-date
                        :model-value="modelValue"
                        mask="DD/MM/YYYY"
                        @update:model-value="value => $emit('update:modelValue', value)"
                    />
                </q-popup-proxy>
            </q-icon>
        </template>
    </q-input>
</template>

<script>
export default {
    name: "TkDateField",
    emits: ["update:modelValue"],
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        disable: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        fieldRules() {
            return [
                v => {
                    const value = String(v ?? "").trim();
                    return value === "" || /^\d{2}\/\d{2}\/\d{4}$/.test(value) || "Use DD/MM/YYYY.";
                },
                ...this.rules,
            ];
        },
    },
};
</script>
